export default __webpack_public_path__ + "static/media/EHS-losses.0b63fe45.svg";